// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item___kpPF","avatar":"Item_avatar__37t_s","man":"Item_man__2tGwu","position":"Item_position__y81Ry"};